(function () {
  if (window.__videoPauseToggleInit) return;
  window.__videoPauseToggleInit = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.video-pause-toggle');
    if (!btn) return;

    var scope = btn.closest('[data-video-pause-scope]');
    if (!scope) return;

    var videos = scope.querySelectorAll('video');
    if (!videos.length) return;

    var shouldPause = !btn.classList.contains('is-paused');
    videos.forEach(function (video) {
      if (shouldPause) {
        video.pause();
      } else {
        video.play();
      }
    });

    btn.classList.toggle('is-paused', shouldPause);
    btn.setAttribute('aria-label', shouldPause ? btn.dataset.playLabel : btn.dataset.pauseLabel);
  });
})();
